import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TimezoneComponent } from './timezone/timezone.component';

const routes: Routes = [
  {
    path: 'timezone',
    component: TimezoneComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WizardRoutingModule { }
